/**
 * 整个项目api的管理
 */
import { filterQuery } from '@/utils'
import { get } from "../utils/Cache";
import request from "./request";
export default {
  // home 组件 左侧表格数据
  getTableData(params) {
    // console.log(params);
    return request({
      url: '/home/getTableData',
      method: 'get',
      data: params,
      // 单独接口 mock 开启
      mock: true
    })
  },
  getCountData() {
    return request({
      url: '/home/getCountData',
      method: 'get',
      // 单独接口 mokc开启
      mock: true
    })
  },
  getChartData() {
    return request({
      url: '/home/getChartData',
      method: 'get',
      mock: true
    })
  },
  // getUserList(params) {
  //   console.log('传递参数',params);
  //   return request({
  //     url: '/user/getUserList',
  //     method: 'get',
  //     mock: true,
  //     data: params
  //   })
  // },
  addUser(params) {
    console.log('addUser',params);
    return request({
      url: '/user/addUser',
      method: 'post',
      mock: false,
      data: params
    })
  },
  updateUser(params) {
    console.log('updateUser',params);
    return request({
      url: '/user/updateUser',
      method: 'post',
      mock: false,
      data: params
    })
  },
  deleteUser(params) {
    console.log('deleteUser',params);
    return request({
      url: '/user/deleteUser',
      method: 'get',
      mock: false,
      data: params
    })
  },



  
  // 用户登录
  login(params) {
    console.log('getMenu',params);
    // const urlWithParams = `/permission/getMenu/${params}?123`;
    return request({
      url: '/user/login',
      mock: true,
      // url: '/permission/getMenu/',
      // url: urlWithParams,

      // mock: false,
      method: 'post',
      // method: 'put',

      data: params
    })
  },
  // 登出
  logOut(params){
    return request({
      url: '/user/logout',
      mock: true,
      data: params,
      method: 'post',
    })
  },
  // 修改密码 返回新token，更新缓存
  // changePwd(params) {
  //   return request({
  //     url:'/user/modify-password',
  //     method: 'post',
  //     mock: false,
  //     data: params
  //   })
  // },
  
  //  账号管理
  queryUserList(params) {
    return request({
      url: 'userManage/user-list',
      mehtod: 'get',
      mock: false,
      data: params
    })
  },

  getUsermanage(params) {
    console.log('传递参数',params);
    return request({
      url: '/user/getUsermanage',
      method: 'get',
      mock: true,
      data: params
    })
  },
  addUsermanage(params) {
    console.log('addUsermanage',params);
    return request({
      url: '/user/addUsermanage',
      method: 'post',
      mock: false,
      data: params
    })
  },
  updateUsermanage(params) {
    console.log('updateUser',params);
    return request({
      url: '/user/updateUsermanage',
      method: 'post',
      mock: false,
      data: params
    })
  },
  deletUsermanage(params) {
    console.log('deleteUser',params);
    return request({
      url: '/user/deletUsermanage',
      method: 'get',
      mock: false,
      data: params
    })
  },













  getRoles(params) {
    console.log('getRoles', params);
    return request({
      url: 'userManage/getRoles',
      mehtod: 'get',
      mock: false,
      data: params
    })
  },







  // 设备列表
  getDevicesList(params) {
    return request({
      url: 'device/devices-list',
      mehtod: 'get',
      mock: false,
      data: params
    })
  },


   
  // // 获取OTA列表
  // getOTA(params) {
  //   // console.log('getOTA',params);
  //   return request({
  //     url: 'OTA/getOTA',
  //     mehtod: 'get',
  //     mock: false,
  //     data: params
  //   })
  // },
  // // 添加OTA
  // addOTA(params) {
  //   console.log(params);
  //   return request({
  //     url: '/OTA/addOTA',
  //     mehtod: 'post',
  //     mock: false,
  //     data: params
  //   })
  // },

  // // 编辑OTA
  // updateOTA(params) {
  //   return request({
  //     url: '/OTA/updateOTA',
  //     mehtod: 'post',
  //     mock: false,
  //     data: params
  //   })
  // },





  // API 


  // 地图API
  getLocations(params) {
    return request({
      url: '/map/list-map',
      method: 'post',
      mock: true,
      data: params
    })
  },

  // 获取设备信息
  getMapDevice_info(params) {
    console.log('getMapDevice_info',params);
    return request({
      url: `/map/device-info?mac=${params.IMEI}`,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 获取 产品 分析 
  getbarData(params) {
    return request({
      url: `statistics/list-product-count`,
      method: 'get',
      mock: true,
      data: params
    })
  },
  // 获取国家占比
  getPieData(params) {
    return request({
      url: `statistics/list-country-count`,
      method: 'get',
      mock: true,
      data: params
    })
  },
  // 获取设备当前总数、在线数量、通讯正常数量
  getDeviceData(){
    return request({
      url: `/statistics/list-device-online`,
      method: 'get',
      mock: true,
    })
  },

  // 设备管理API
  // device-info/list-menu-product
  getProductList(params) {
    return request({
      url: '/device-inventory/list-menu-product',
      method: 'get',
      mock: true,
      data: params
    })
  },
  getAgentList(params) {
    return request({
      url: '/device-inventory/list-menu-agent',
      method: 'get',
      mock: true,
      data: params
    })
  },
  // /device-inventory/device-list
  getDeviceList(params,config) {
    const urlWithParams = `/device-inventory/device-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // // 获取设备信息
  getDeviceDetailInfo(mac){
    const urlWithParams = `/device-inventory/device-info?mac=${mac}`;
    return request({
      url: urlWithParams,
      method: 'get',
    })
  },
  // /device-inventory/bind-user-list
  getBindList(params) {
    return request({
      url: `/device-inventory/bind-user-list?mac=${params.mac}`,
      method: 'get',
      mock: true,
      data:  params
    })
  },
  // 设备导入记录
  getBatchRecord(params,config) {
    const urlWithParams = `/device-import/device-auth-batch?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 单个批次记录
  getTagRecord(params,config){
    const urlWithParams = `/device-import/device-auth?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 设备出库批次记录
  getSaledrList(params,config){
    const urlWithParams = `/device-export/export-batch-list?pageNo=${config.pageNo}&size=${config.size}`;
    if (params) {
      return request({
        url: urlWithParams,
        method: 'post',
        data:  params
      })
    }else{
      return request({
        url: urlWithParams,
        method: 'post',
      })
    }
  },
  // 设备出库记录
  getDistributeList(params,config){
    console.log(config);
    const urlWithParams = `/device-export/device-export-list?pageNo=${config.pageNo}&size=${config.size}`;
    if (params) {
      return request({
        url: urlWithParams,
        method: 'post',
        data:  params
      })
    }else{
      return request({
        url: urlWithParams,
        method: 'post',
      })
    }
  },
  // 设备出库
  confirmSaled(params){
    const urlWithParams = `/device-export/export-device`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 部门菜单
  getDepartmentMenu(){
    const urlWithParams = `/device-export/department-menu`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
    })
  },
  // 设备详情1
  // /device-inventory/device_info
  getDeviceInfo(params) {
    console.log('getDeviceInfo',params);
    const urlWithParams = `/device-inventory/device-info?mac=${params.mac}`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data:  params
    })
  },
  // 修改设备名称
  saveDev(params,data) {
    console.log('saveDev',params);
    let urlWithParams;
    if (params.device_name) {
      urlWithParams = `/device-inventory/device-update?mac=${params.mac}&device_name=${params.device_name}`
    }else {
      urlWithParams = `/device-inventory/device-update?mac=${params.mac}`;
    }
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: data
    })
  },
  // OTA历史记录
  getUpgradeRecord(params,config,data) {
    const urlWithParams = `/device/device-history-ota?mac=${params}&pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  data
    })
  },

  // 设备分析
  // 获取个人产品点位
  getPersonalPoint(product_key){
    const urlWithParams = `/user/${product_key}/attr-savings`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true
    })
  },
  // 保存个人
  setPersonalPoint(product_key,params) {
    const urlWithParams = `/user/${product_key}/attr-savings`;
    return request({
      url: urlWithParams,
      method: 'POST',
      mock: true,
      data:params
    })
  },
  // 获取产品曲线名称
  getCurveName(params) {
    console.log('getCurveName',params);
    const urlWithParams = `/device-inventory/list-curve-name?product_key=${params.product_key}`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data:  params
    })
  },
  // 获取产品曲线
  getProductCurve(params) {
    return request({
      url: `/device-inventory/list-curve`,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 机型设定查询
  getDevice_model(params){
    return request({
      url: `/device-inventory/device-model?mac=${params.mac}`,
      method: 'get',
      mock: true,
      // data:  params
    })
  },
  
  // 统计分析
  // 经销商数量
  getAgentNumber(params) {
    return request({
      url: `/statistics/list-agent-count`,
      method: 'get'
    })
  },
  // 报警前十
  getAlarmTopTen(params) {
    return request({
      url: `/statistics/list-alarm-count`,
      method: 'get',
      mock: true,
      data:  params
    })
  },

  // 事件管理APi
  // /event/alarm-list
  getAlarmList(params,config) {
    const urlWithParams = `/event/alarm-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 设备日志
  getDevHistory(params,config) {
    const urlWithParams = `/device-history-data/history-data?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 设备日志导出数据点
  exportAttrList(params,product_key) {
    console.log('exportAttrList',params);
    const urlWithParams = `/device-history-data/attr-savings/${product_key}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  getAttrList(product_key) {
    const urlWithParams = `/device-history-data/attr-savings/${product_key}`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
    })
  },
  // 导出日志记录
  getDevHistoryRecord(config) {
    const urlWithParams = `/device-history-data/export-history?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
    })
  },
  // 设备控制日志
  getDevControlLog(params,config) {
    const urlWithParams = `/event/control-log?pageNo=${config.pageNo}&size=${config.size}`;
    // const urlWithParams = `/event/control-log`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 创建产品
  createProduct(params) {
    const urlWithParams = `/product/create`;
    return request({
      url: urlWithParams,
      method: 'post',
      data:  params
    })
  },
  // 产品列表信息
  getProductMessage(params,product_name){
    console.log('getProductData',params,product_name);
    if (product_name) {
      const urlWithParams = `/product/product-info?&product_name=${product_name}&pageNo=${params.pageNo}&size=${params.size}`;
      return request({
        url:urlWithParams,
        method: 'post',
        mock: true,
        data: params
      })
    }else {
      const urlWithParams = `/product/product-info?&pageNo=${params.pageNo}&size=${params.size}`;
      return request({
        url:urlWithParams,
        method: 'post',
        mock: true,
        data: params
      })
    }
  },
  // 获取寄存器列表
  getRegisterList(product_key) {
    return request({
      url: `/product/list-register?product_key=${product_key}`,
      method: 'get',
      mock: true,
    })
  },
  // 添加寄存器
  addRegister(params) {
    console.log('addRegister',params);
    return request({
      url: `/product/add-register`,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 删除寄存器
  deleteRegister(params) {
    console.log('deleteRegister',params);
    return request({
      url:`/product/delete-register?product_key=${params.product_key}&register_name=${params.register_name}`,
      mehtod:'get',
      mock: true,
      data:''
    })
  },
  // OTA列表
  // device/page-ota
  getOTAList(params,config,product_key) {
    console.log('getOTAList',params, product_key);
    const urlWithParams = `/device/page-ota?product_key=${product_key}&pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url:urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 产品记录
  getProductRecords(params,id) {
    // /device/history-ota
    // console.log('getOTAList',params, product_key);
    const urlWithParams = `/device/history-ota?id=${id}&pageNo=${params.pageNo}&size=${params.size}`;
    return request({
      url:urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },



  // device/upload-ota
  // uploadOTA(params,file) {
  //   console.log('uploadOTA',params);
  //   console.log(file);
  //   const urlWithParams = `/device/upload-ota?file=${file}&enable_sw_ver=${params.enable_sw_ver}&firmware_hd_ver=${params.firmware_hd_ver}&firmware_id${params.firmware_id}&firmware_name=${params.firmware_name}&firmware_path=${params.firmware_path}&firmware_sw_ver=${params.firmware_sw_ver}&firmware_type=1&product_key=${params.product_key}&push_status=${params.push_status}`;
  //   return request({
  //     // url: '/device/upload-ota',
  //     url:urlWithParams,
  //     method: 'post',
  //     mock: true,
  //     data: params
  //   })
  // },
  // // 
  // updateOTA(params) {
  //   console.log('updateOTA',params);
  //   const urlWithParams = `/device/update-ota?enable_sw_ver=${params.enable_sw_ver}&firmware_hd_ver=${params.firmware_hd_ver}&firmware_name=${params.firmware_name}&firmware_path=${params.firmware_path}&firmware_sw_ver=${params.firmware_sw_ver}&firmware_type=1&product_key=${params.product_key}&push_status=${params.push_status}`;
  //   return request({
  //     // url: '/device/update-ota',
  //     url:urlWithParams,
  //     method: 'post',
  //     mock: true,
  //     data: params
  //   })
  // },
  // delete-ota
  deleteOTA(params) {
    console.log('deleteOTA',params);
    const urlWithParams = `/device/delete-ota?firmware_id=${params.firmware_id}`;
    return request({
      // url: '/device/update-ota',
      url:urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },

  // 经销商列表
  getDistributorList(params,config) {
    const urlWithParams = `/agent-management/agent-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 创建经销商
  createDistributor(params) {
    const urlWithParams = `/agent-management/agent-info`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 编辑经销商
  editDistributor(params,agent_id) {
    const urlWithParams = `/agent-management/agent-info/${agent_id}`;
    return request({
      url: urlWithParams,
      method: 'put',
      mock: true,
      data: params
    })
  },
  // 获取经销商信息
  getDistributorinfo(params,agent_id) {
    console.log(agent_id);
    const urlWithParams = `/agent-management/agent-info/${agent_id}`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      data: params
    })
  },
  // 删除
  deleteDistributor(params,agent_id) {
    console.log('deleteDistributor',params);
    const urlWithParams = `/agent-management/agent-info/${agent_id}`;
    return request({
      url: urlWithParams,
      method: 'delete',
      mock: true,
      // data: params
    })
  },

  // 部门
  getDepartmentList(params,config){
    console.log('getDepartmentList',params);
    const urlWithParams = `/department/department-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 新增部门
  createDepartment(params){
    const urlWithParams = `/department/department-info`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 更新部门信息
  editDepartment(params,uid){
    console.log('editDepartment',uid);
    const urlWithParams = `/department/${uid}/department-info`;
    return request({
      url: urlWithParams,
      method: 'put',
      mock: true,
      data:  params
    }) 
  },
  // 获取部门信息
  getDepartmentinfo(params,uid){
    console.log(uid);
    const urlWithParams = `/department/${uid}/department-info`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      data: params
    })
  },

  // 用户
  // 用户列表 查询
  getUserList(params,config) {
    const urlWithParams = `/user-manage/user-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 获取用户信息/user-manage/{uid}/info
  getAppUserInfo(params,uid){
    console.log('getAppUserInfo',uid);
    const urlWithParams = `/user-manage/${uid}/info`
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      data:  params
    })
  },
  // 更新用户信息
  updateAppUserInfo(params,uid){
    console.log('updateAppUserInfo',uid);
    const urlWithParams = `/user-manage/${uid}/info`
    return request({
      url: urlWithParams,
      method: 'put',
      mock: true,
      data:  params
    })
  },
  // 用户绑定设备
  getUserBindDevices(params,uid,config) {
    console.log('getUserBindDevices',params);
    const urlWithParams = `/user-manage/${uid}/bind-device?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      // method: 'post',
      method: 'get',
      mock: true,
      data:  params
    })
  },
  // 解绑设备
  UnbindDevice(uid,device_key){
    console.log('UnbindDevice',uid,device_key);
    const urlWithParams = `/user-manage/${uid}/unbind-device/${device_key}`
    return request({
      url: urlWithParams,
      method: 'delete',
      mock: true,
      // data:  params
    })
  },


  // 角色
  // 角色列表
  getRoleList(params,config) {
    const urlWithParams = `/role/role-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data:  params
    })
  },
  // 获取权限集合
  getPermissionList(){
    const urlWithParams = `/role/permission-info`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data: params
    })
  },
  // 获取角色详情
  getRoleInfo(rid){
    const urlWithParams = `/role/${rid}/role-info`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data: params
    })
  },
  // 编辑角色
  editRole(params,rid){
    const urlWithParams = `/role/${rid}/role-info`;
    return request({
      url: urlWithParams,
      method: 'put',
      mock: true,
      data: params
    })
  },
  // 新增角色
  createRole(params){
    const urlWithParams = `/role/role-info`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 删除角色
  deleteRole(rid){
    const urlWithParams = `/role/${rid}/role-info`;
    return request({
      url: urlWithParams,
      method: 'delete',
      mock: true,
      // data: params
    })
  },


  // 账号
  // 获取角色菜单
  getRoleMenuList(){
    const urlWithParams = `/account/role-menu`;
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data: params
    })
  },
  // 账户列表
  getAccountList(params,config){
    const urlWithParams = `/account/account-list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 账户详情
  getAccountInfo(uid){
    const urlWithParams = `/account/${uid}/account-info`
    return request({
      url: urlWithParams,
      method: 'get',
      mock: true,
      // data: params
    })
  },
  // 更新
  updateAccountInfo(params,uid){
    const urlWithParams = `/account/${uid}/account-info`
    return request({
      url: urlWithParams,
      method: 'put',
      mock: true,
      data: params
    })
  },
  //创建
  createAccountInfo(params){
    const urlWithParams = `/account/account-info`
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 修改用户信息
  editUserInfo(uid,params){
    const urlWithParams = `/user-manage/${uid}/info`
    return request({
      url: urlWithParams,
      method: 'PUT',
      mock: true,
      data: params
    })
  },
  // 获取用户信息
  getUserInfo(uid) {
    const urlWithParams = `/user-manage/${uid}/info`
    return request({
      url: urlWithParams,
      method: 'get'
    })
  },
  // 修改密码
  editPassword(params){
    const urlWithParams = `/user/modify-password`
    return request({
      url: urlWithParams,
      method: 'POST',
      mock: true,
      data: params
    })
  },
  // iccid列表
  getIccidList(queryParams,config){
    console.log('queryParams',queryParams);
    const urlWithParams = `/device-iccids/list?pageNo=${config.pageNo}&size=${config.size}`;
    const  params = filterQuery(queryParams)
    if (params) {
      return request({
        url: urlWithParams,
        method: 'post',
        data: params
      })      
    }else{
      return request({
        url: urlWithParams,
        method: 'post'
      })
    }
  },
  // 更改iccid
  editIccidInfo(params){
    const urlWithParams = `/device-iccids/expired-day`
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      data: params
    })
  },
  // 导出Iccid列表
  exportIccidList(params){
    const urlWithParams = `/device-iccids/exports`
    return request({
      url: urlWithParams,
      method: 'post',
      mock: true,
      responseType: 'blob', // 设置响应类型为blob以接收二进制数据
      data: params
    })
  },
  /**
   * 更新配置文件
   */
  updateConfig(params) {
    return request({
      url: `/product/check_update`,
      method: 'POST',
      data: params
    })
  },
  /**
   * 分页查询指令模版列表
   * @param {Object} params - 查询参数
   * @param {Object} config - 分页配置
   * @returns {Promise} API响应
   */
  getInstructionList(params,config){
    const urlWithParams = `/param_model/model_list?pageNo=${config.pageNo}&size=${config.size}`;
    return request({
      url: urlWithParams,
      method: 'post',
      data: params
    })
  },
  // 指令模版菜单
  getInstructionTemplateMenu(){
    const urlWithParams = `/param_model/all_list`;
    return request({
      url: urlWithParams,
      method: 'post',
    })
  },
  // 创建指令模版
  createInstructionTemplate(params){
    const urlWithParams = `/param_model/create`;
    return request({
      url: urlWithParams,
      method: 'post',
      data: params
    })
  },
  // 修改指令模板
  updateInstructionTemplate(model_key, params){
    const urlWithParams = `/param_model/${model_key}/info`;
    return request({
      url: urlWithParams,
      method: 'put',
      data: params
    })
  },
  // 删除指令模板
  deleteInstructionTemplate(model_key){
    const urlWithParams = `/param_model/${model_key}`;
    return request({
      url: urlWithParams,
      method: 'delete',
    })
  },
  // 查询指令模板详情
  getInstructionTemplateDetail(model_key){
    const urlWithParams = `/param_model/${model_key}/info`;
    return request({
      url: urlWithParams,
      method: 'get'
    })
  }
}

